import PriceCreateComponent from '@components/PriceCreateComponent/PriceCreateComponent'
import React from 'react'

const PriceCreatePage = () => {
  return (
    <div>
      <PriceCreateComponent />
    </div>
  )
}

export default PriceCreatePage
